import * as S from './styles';
import { usePathname } from 'next/navigation';
import MenuItem from '@/components/molecules/MenuItem';
import { IconeCasa } from '@/components/atoms/Icones/IconeCasa';
import { IconeAjuda } from '@/components/atoms/Icones/IconeAjuda';
import { IconeCompras } from '@/components/atoms/Icones/IconeCompras';
import Link from 'next/link';
import { MouseEventHandler } from 'react';
import { IconeCartao } from '@/components/atoms/Icones/IconeCartao';
import { registrarEvento } from '@/services/googleAnalytics';
import { useSession } from 'next-auth/react';

interface MenuLateralCorpoProps {
  $onClick: MouseEventHandler<HTMLDivElement | HTMLAnchorElement> | undefined;
  $visualizacaoWebView?: boolean;
}

export default function MenuLateralCorpo(props: MenuLateralCorpoProps) {
  const { $onClick, $visualizacaoWebView = false } = props;
  const caminhoURL = usePathname();
  const { status } = useSession();

  return (
    <S.Container $visualizacaoWebView={$visualizacaoWebView}>
      <Link
        href="/"
        onClick={(event) => {
          registrarEvento('menuHamburguerCliqueIrParaHome', {});
          if ($onClick) $onClick(event);
        }}
      >
        <MenuItem
          $state={caminhoURL === '/' ? 'selected' : 'default'}
          $variant="solid"
          $text="Início"
          Icon={IconeCasa}
        />
      </Link>
      {status === 'authenticated' ? (
        <Link
          href="/minha-conta/minhas-compras"
          onClick={(event) => {
            registrarEvento('menuHamburguerCliqueIrParaMinhasCompras', {});
            if ($onClick) $onClick(event);
          }}
        >
          <MenuItem
            $state={
              caminhoURL.includes('minhas-compras') ? 'selected' : 'default'
            }
            $variant="solid"
            $text="Minhas compras"
            Icon={IconeCompras}
          />
        </Link>
      ) : null}
      {status === 'authenticated' ? (
        <Link
          href="/minha-conta/minha-carteira"
          onClick={(event) => {
            registrarEvento('menuHamburguerCliqueIrParaMinhaCarteira', {});
            if ($onClick) $onClick(event);
          }}
        >
          <MenuItem
            $state={
              caminhoURL.includes('minha-carteira') ? 'selected' : 'default'
            }
            $variant="solid"
            $text="Minha carteira"
            Icon={IconeCartao}
          />
        </Link>
      ) : null}
      <Link
        href="/ajuda"
        onClick={(event) => {
          registrarEvento('menuHamburguerCliqueIrParaCentralAjuda', {});
          if ($onClick) $onClick(event);
        }}
      >
        <MenuItem
          $state={caminhoURL === '/ajuda' ? 'selected' : 'default'}
          $variant="solid"
          $text="Central de ajuda"
          Icon={IconeAjuda}
        />
      </Link>
    </S.Container>
  );
}
